import { ref } from 'vue'

// 登录态唯一数据源：token 同时保存在响应式 ref 和 localStorage 中。
// ref 让界面（如登录卡片）能在 token 失效时立即切换，无需手动刷新浏览器。
export const authToken = ref(localStorage.getItem('admin_token') || '')
export const authUser = ref(localStorage.getItem('admin_user') || '')

// 登录：写入 ref 与 localStorage
export function login(token, username = '') {
  authToken.value = token || ''
  if (authToken.value) {
    localStorage.setItem('admin_token', authToken.value)
  } else {
    localStorage.removeItem('admin_token')
  }
  if (username) {
    authUser.value = username
    localStorage.setItem('admin_user', username)
  }
}

// 退出登录 / token 失效：清除 ref 与 localStorage
export function logout() {
  authToken.value = ''
  authUser.value = ''
  localStorage.removeItem('admin_token')
  localStorage.removeItem('admin_user')
}

const auth = { token: authToken, user: authUser, login, logout }

export default auth
